export default __webpack_public_path__ + "static/media/mutual-ic-pickup.bfa1046e.svg";